import * as types from 'constants/ActionTypes';
import { CHECK_LIST_ADVICE_STATISTICS_REDUCE_URL } from 'constants/ApiConstants';
import { CHECKLIST_ADVICE_URL, STATS_STATUS } from 'constants/StatisticsConstants';

export const fetchCategoriesStatsDistributionRequest = params => ({
  type: types.FETCH_CATEGORIES_STATS_DISTRIBUTION_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${CHECKLIST_ADVICE_URL[params.mode]}/reduce`,
      params: {
        ...params,
        reducer: ['id,count', 'category,none'],
        status: STATS_STATUS,
        sort: 'id,desc',
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
});

export const fetchCategoriesStatsDistributionSuccess = data => ({
  type: types.FETCH_CATEGORIES_STATS_DISTRIBUTION_SUCCESS,
  data,
});

export const fetchCategoriesStatsDistributionFailure = error => ({
  type: types.FETCH_CATEGORIES_STATS_DISTRIBUTION_FAILURE,
  error,
});

export const fetchCategoriesStatsRevenueRequest = params => ({
  type: types.FETCH_CATEGORIES_STATS_REVENUE_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${CHECKLIST_ADVICE_URL[params.mode]}/reduce`,
      params: {
        ...params,
        reducer: ['price,sum', 'acceptedAmount,sum', 'category,none'],
        status: STATS_STATUS,
        sort: 'id,desc',
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
});

export const fetchCategoriesStatsRevenueSuccess = data => ({
  type: types.FETCH_CATEGORIES_STATS_REVENUE_SUCCESS,
  data,
});

export const fetchCategoriesStatsRevenueFailure = error => ({
  type: types.FETCH_CATEGORIES_STATS_REVENUE_FAILURE,
  error,
});

export const addFiltersCategoriesStatsRevenueFilters = payload => ({
  type: types.ADD_FILTERS_CATEGORIES_STATS_REVENUE,
  payload,
});

export const fetchCategoriesStatsContributorRequest = params => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${CHECKLIST_ADVICE_URL[params.mode]}/reduce`,
      params: {
        ...params,
        reducer: ['id,count', 'category,none', 'price,sum', 'acceptedAmount,sum', 'amountRatio,func'],
        status: STATS_STATUS,
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
});

export const fetchCategoriesStatsContributorSuccess = data => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_SUCCESS,
  data,
});

export const fetchCategoriesStatsContributorFailure = error => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_FAILURE,
  error,
});

export const fetchStatisticSeverity = (params, meta = {}) => ({
  type: types.FETCH_STATISTICS_SEVERITY,
  payload: {
    request: {
      method: 'GET',
      url: CHECK_LIST_ADVICE_STATISTICS_REDUCE_URL,
      params: {
        ...params,
        reducer: ['id,count', 'severity,none', 'acceptedAmount,sum', 'price,sum', 'amountRatio,func'],
        status: STATS_STATUS,
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
  meta,
});

export const fetchStatisticSeveritySuccess = (stats, meta = {}) => ({
  type: types.FETCH_STATISTICS_SEVERITY_SUCCESS,
  payload: stats,
  meta,
});

export const fetchStatisticSeverityFailure = (message, meta = {}) => ({
  type: types.FETCH_STATISTICS_SEVERITY_FAILURE,
  payload: message,
  error: true,
  meta,
});

const abstractFetchTop = (field, reducer, params, meta = {}) => ({
  type: types.FETCH_STATISTICS_TOP_ANYTHING,
  payload: {
    request: {
      method: 'GET',
      url: CHECK_LIST_ADVICE_STATISTICS_REDUCE_URL,
      params: {
        ...params,
        reducer: [`${reducer},none`, 'price,sum'],
        size: 1,
        sort: ['price,desc'],
        status: STATS_STATUS,
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
  meta: { ...meta, reducer, field, [field]: params?.[field] },
});

export const fetchTopAnythingSuccess = (item, meta = {}) => ({
  type: types.FETCH_STATISTICS_TOP_ANYTHING_SUCCESS,
  payload: item,
  meta,
});

export const fetchTopAnythingFailure = (message, meta = {}) => ({
  type: types.FETCH_STATISTICS_TOP_ANYTHING_FAILURE,
  payload: message,
  error: true,
  meta,
});

export const fetchTopSeverityAuthor = (params, meta = {}) =>
  abstractFetchTop('severity', 'createdByName', params, { ...meta, key: 'topAuthor' });

export const fetchTopSeveritySender = (params, meta = {}) =>
  abstractFetchTop('severity', 'sentByName', params, { ...meta, key: 'topSender' });

export const fetchCategoriesStatsContributorTopAuthorRequest = params => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${CHECKLIST_ADVICE_URL[params.mode]}/reduce`,
      params: {
        ...params,
        reducer: ['createdByName,none', 'price,sum'],
        size: 1,
        sort: ['price,desc'],
        status: STATS_STATUS,
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
  meta: { category: params?.category },
});

export const fetchCategoriesStatsContributorTopAuthorSuccess = (data, meta) => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_SUCCESS,
  data,
  meta,
});

export const fetchCategoriesStatsContributorTopAuthorFailure = (error, meta) => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_FAILURE,
  error,
  meta,
});

export const fetchCategoriesStatsContributorTopSenderRequest = params => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${CHECKLIST_ADVICE_URL[params.mode]}/reduce`,
      params: {
        ...params,
        reducer: ['sentByName,none', 'price,sum'],
        sort: ['price,desc'],
        size: 1,
        status: STATS_STATUS,
        ...(params.sentFrom ? { exist: 'interventionSentOn' } : {}),
      },
    },
  },
  meta: { category: params?.category },
});

export const fetchCategoriesStatsContributorTopSenderSuccess = (data, meta) => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_SUCCESS,
  data,
  meta,
});

export const fetchCategoriesStatsContributorTopSenderFailure = (error, meta) => ({
  type: types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_FAILURE,
  error,
  meta,
});
